import { NotificationPreferencesPanel } from '../../features/notification-preferences';
import { NotificationRulesPanel } from '../../features/notification-rules';
import { useOrganizationSettings } from './use-organization-settings';
import { SettingsShell } from './settings-shell';

// Owner, not manager: the PUT behind these switches is owner-only and 403s an admin.
// Personal switches sit on this tab too: the same events on two tabs read as two settings.
export const NotificationRulesSettingsPage = () => {
  const { actor } = useOrganizationSettings();

  return (
    <SettingsShell
      active="/settings/notifications"
      question="What people are told about, and where — for everyone, and just for you."
    >
      <NotificationRulesPanel editable={actor?.role === 'owner'} />
      <NotificationPreferencesPanel />
    </SettingsShell>
  );
};
